import { render, staticRenderFns } from "./InstanceDash.vue?vue&type=template&id=0bb33aea&"
import script from "./InstanceDash.vue?vue&type=script&lang=js&"
export * from "./InstanceDash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports